import React from 'react';

export const DemoContainer = ({ children }) => (
  <div className="p-5 mb-8 bg-gray-200 border border-gray-400 rounded sm:p-10">
    {children}
  </div>
);
